import { required, optional, obj } from 'AppReact/schema';

const address = {
    city: required('string'),
    state: required('string'),
    street: required('string'),
    zip: required('string'),
}

export default {
    id: required('integer'),
    address: obj(address),
    // code: required('string'),
    name: required('string'),

    phone: optional('string'),
    website: optional('string'),
    time_zone: optional('string'),
    logo: optional('string'),
    logo_id: optional('integer'),
    icon: optional('string'),
    icon_id: optional('integer'),
    external_id: optional('string'),
    group_email: optional('string'),
    banner: optional('string'),
    banner_id: optional('integer'),
    billing_email: optional('string'),
    billing_phone: optional('string'),
    billing_name: optional('string'),
    billing_address: obj(address)
}